import { API } from 'aws-amplify'
import APIRoutes from '../../api/routes'

export const UPDATEUSERALERTS = 'UPDATEUSERCONTACT'
export const SAVEUSERCONTACT = 'SAVEUSERCONTACT'
export const UPDATECONTACTS = 'UPDATECONTACTS'

export const fetchUserAlerts = dispatch => {
  API.get('DEFAULT_ENDPOINT', APIRoutes.alertContacts).then(res => {
    dispatch({
      type: UPDATEUSERALERTS,
      payload: { alerts: res.details, user_contacts: res.user_contacts },
    })
  })
}

export const saveUserContacts = (dispatch, formData, callback) => {
  API.post('DEFAULT_ENDPOINT', APIRoutes.saveContact, {
    body: formData,
  }).then(res => {
    callback && callback()
    fetchUserAlerts(dispatch)
  })
}

export const saveAlert = (dispatch, formData, callback) => {
  API.post('DEFAULT_ENDPOINT', APIRoutes.alertContacts, {
    body: formData,
  }).then(res => {
    callback && callback('Successfully updated Alert Status')
    fetchUserAlerts(dispatch)
  })
}

export const saveDeliveryMethods = (dispatch, formData, callBack) => {
  API.post('DEFAULT_ENDPOINT', APIRoutes.saveDeliveryMethods, {
    body: formData,
  }).then(res => {
    fetchUserAlerts(dispatch)
    callBack && callBack('Successfully updated Delivery Methods')
  })
}
